/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_No_Data_ErrorInputs */

const en_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data found in response`)
};

const fr_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnee trouvee dans la reponse`)
};

const de_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Daten gefunden.`)
};

const it_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato trovato nella risposta`)
};

const ru_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные в ответе не найдены.`)
};

const es_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron datos en la respuesta`)
};

const zh_cn2_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到响应数据`)
};

const ja_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`応答にデータが見つかりません`)
};

const hi_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तर में कोई डेटा नहीं मिला`)
};

const pt_pt2_voice_manager_no_data_error = /** @type {(inputs: Voice_Manager_No_Data_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dado encontrado na resposta.`)
};

/**
* | output |
* | --- |
* | "No data found in response" |
*
* @param {Voice_Manager_No_Data_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_no_data_error = /** @type {((inputs?: Voice_Manager_No_Data_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_No_Data_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_no_data_error(inputs)
	if (locale === "de") return de_voice_manager_no_data_error(inputs)
	if (locale === "it") return it_voice_manager_no_data_error(inputs)
	if (locale === "ru") return ru_voice_manager_no_data_error(inputs)
	if (locale === "es") return es_voice_manager_no_data_error(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_no_data_error(inputs)
	if (locale === "ja") return ja_voice_manager_no_data_error(inputs)
	if (locale === "hi") return hi_voice_manager_no_data_error(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_no_data_error(inputs)
	return en_voice_manager_no_data_error(inputs)
});